export enum GameType {
    MultiplierMadness = 1,
    TopDog = 2,
    Bullseye = 3,
    Percentile = 4,
    Milestone = 5,
    Connect3 = 6,
    Blackout = 7,
    TopTeam = 8,
    Raffle = 9,
    Brackets = 10
};

export interface BracketTournamentRounds {
    RoundID: number;
    RoundNumber: number;
    RoundName: string;
    StartDate: Date;
    EndDate: Date;
}
